import React from "react";
import classNames from "classnames";

import { Props, DateType } from "./types";
import { Days } from "./days";
import { Months } from "./months";
import { Years } from "./years";
import styles from "./styles.scss";

function WeekCalendar({ date, initialCursor, ...props }: Props) {
  const [cursor, setCursor] = React.useState(
    new Date(
      initialCursor
        ? initialCursor
        : new Date(date.year, date.month, date.day).toISOString(),
    ),
  );
  const [currentView, setCurrentView] = React.useState("days");

  const handleCursorChange = (newDate: Partial<DateType>) => {
    const { year, month, day } = {
      year: cursor.getFullYear(),
      month: cursor.getMonth(),
      day: cursor.getDate(),
      ...newDate,
    };

    setCursor(new Date(year, month, day));
  };

  return (
    <div
      className={classNames(styles.calendar, {
        [styles.month]: currentView === "months",
        [styles.year]: currentView === "years",
      })}
    >
      <div className={styles.years}>
        <Years
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          today={props.today}
        />
      </div>
      <div className={styles.months}>
        <Months
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          today={props.today}
        />
      </div>
      <div className={styles.days}>
        <Days
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editWeek={props.editWeek}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          today={props.today}
        />
      </div>
    </div>
  );
}

export { WeekCalendar };
